import type { z, ZodRawShape } from "zod";
import type { SectionDef } from "./_types";
import { branding } from "./branding";
import { vocabulary } from "./vocabulary";
import { app } from "./app";
import { billing } from "./billing";

export const SECTIONS = { branding, vocabulary, app, billing } as const satisfies
  Record<string, SectionDef<ZodRawShape>>;

export type SectionName = keyof typeof SECTIONS;
export type SectionValues<S extends SectionName> = z.infer<(typeof SECTIONS)[S]["schema"]>;

export const FORBIDDEN_LITERALS = [
  ...branding.forbiddenLiterals,
  ...vocabulary.forbiddenLiterals,
  ...app.forbiddenLiterals,
  ...billing.forbiddenLiterals,
] as const;

export const FORBIDDEN_LITERAL_SET: ReadonlySet<string> = new Set(FORBIDDEN_LITERALS);

export { branding, vocabulary, app, billing };
export { flattenVocab, unflattenVocab, newPrefix, upcomingActivitiesTitle, VOCAB_TERM_PATTERN, VOCAB_TERM_MESSAGE, type VocabValues, type GenderedNoun } from "./vocabulary";
export {
  nounGrammar,
  resolveGender,
  lowerTerm,
  capTerm,
  agree,
  agreePlural,
  pluralAdjective,
  type NounGender,
  type GrammarNoun,
  type NounForms,
} from "./nounGrammar";
export {
  bookableBlocksMessages,
  formAmountWithMembersMessage,
  formDeactivateWithMembersMessage,
  stripePermissionWhy,
  type MirrorBookingNoun,
  type MirrorCopyNoun,
  type MirrorCopyNouns,
  type StripePermissionWithNoun,
} from "./serverMirrorCopy";
export {
  normalizeHomeConfig,
  normalizeHomeConfigWithIssues,
  resolveEventsLimit,
  HOME_CONFIG_DEFAULTS,
  HOME_EVENTS_MODES,
  HOME_FEED_TITLE_FALLBACK,
  HOME_LIMITS,
  HOME_TITLE_MAX,
  type HomeConfig,
  type HomeConfigIssue,
  type HomeEventsMode,
} from "./home-config";
export type { SectionDef, FieldMeta } from "./_types";
export type { BrandingValues, VocabularyValues, AppValues, BillingValues, TenantSettings } from "./types";
export { BRANDING_DEFAULTS, VOCABULARY_DEFAULTS, APP_DEFAULTS, BILLING_DEFAULTS } from "./types";
